export default __webpack_public_path__ + "static/media/sample-direct.72398411.png";